import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

// Create Class
export const createLevel = data => post(url.CREATE_LEVEL, data);
export const updateLevel = data => put(url.UPDATE_LEVEL, data);
export const deleteLevel = id => del(url.DELETE_LEVEL + id);
export const fetchAllLevel = () => get(url.FETCH_ALL_LEVEL);